import styled from '@emotion/styled/macro'
import { theme } from 'styles/theme/hav-theme'

export const ActionsRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: ${theme.spacing.xm};
  padding-right: ${theme.spacing.sm};
`
export const DivInput = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: ${theme.spacing.xs} 0px;
`

export const EmptySize = styled.div`
  opacity: 0.2;
`

export const FormActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${theme.spacing.md};
  margin-bottom: ${theme.spacing.md};
`

export const ButtonsRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.sm};

  #material-delete-button {
    :not(:disabled) {
      svg {
        path {
          fill: ${theme.colors.alert.danger.dark};
        }
      }
    }
  }
`

export const SummaryWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${theme.spacing.xm};
  margin-top: ${theme.spacing.md};
  flex-wrap: wrap;
`

export const SummaryRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: ${theme.spacing.lg};

  @media (max-width: ${theme.breakpoints.lg}px) {
    width: 100%;
  }
`

export const SummaryItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  span {
    color: ${theme.colors.neutral.high};
    font-size: ${theme.typography.sizes['2xs']};
    font-weight: ${theme.typography.weight.xl};
  }
`

export const MaterialTitle = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  .tag {
    vertical-align: -${theme.spacing.xs};
    margin-left: ${theme.spacing.xs};
  }
`
export const FactoryWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
`

export const TableWrapper = styled.div`
  display: grid;
  width: 100%;
`

export const StrategyText = styled.span`
  color: ${theme.colors.alert.success.dark};
  font-family: ${theme.typography.family.bold};
  font-weight: ${theme.typography.weight.lg};
`

export const IconSpan = styled.span`
  display: flex;
`

export const NotFoundWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 320px;
  background-color: ${theme.colors.neutral[100]};
  border-radius: ${theme.shapes.borderRadius.md};
  margin: ${theme.spacing.xs} 0;
`

export const NotFoundContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${theme.spacing.md};
  width: 100%;
`
